export const getFormattedCurrency = (value?: number | string): string => value != null && value !== '' ? `$${value.toLocaleString()}` : '';
